// React libraries
import React from 'react';
// Component Style
import { useStyles } from "./TabsStyles";
// Material-UI Styles
import MUITabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
// Components
import { Separator } from '../index';
export const Tabs = props => {
    const classes = useStyles(props);
    const { id, tabItems, index, handleChangeIndex, style } = props;
    return (React.createElement("div", { id: id, style: style },
        React.createElement(MUITabs, { classes: { indicator: classes.indicator }, value: index, onChange: handleChangeIndex }, tabItems.map((tabItem, index) => (React.createElement(Tab, { key: `tabItem${index}`, id: "tabTitle_" + tabItem.id, className: classes.tab, label: tabItem.label, disabled: tabItem.disabled })))),
        React.createElement(Separator, { marginTop: "-2.5px" })));
};
Tabs.defaultProps = {
    defaultTabIndex: 0
};
export default React.memo(Tabs);
